export function checkFaders() {
  var faders = document.querySelectorAll('.fade:not(.faded)');
  
  faders.forEach((el) => {
    if (inScreen(el, 1)) {
      el.classList.add('faded');
    }
  });
}

export function inScreen(el, k) {
  let box = el.getBoundingClientRect();

  return window.innerHeight * k > box.top;
}

export default checkFaders;
